import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SeasonCtx = createContext(null);

export function SeasonProvider({ children }) {
  const [seasons, setSeasons] = useState([]);
  const [activeSeason, setActiveSeason] = useState(null);
  const [selectedSeasonId, setSelectedSeasonId] = useState(
    typeof localStorage !== "undefined" ? localStorage.getItem("csp_season_id") || null : null,
  );
  const [ready, setReady] = useState(false);

  const load = useCallback(async () => {
    try {
      const [s, a] = await Promise.all([api.get("/seasons"), api.get("/seasons/active")]);
      setSeasons(s.data || []);
      setActiveSeason(a.data || null);
      const stored = typeof localStorage !== "undefined" ? localStorage.getItem("csp_season_id") : null;
      const valid = (s.data || []).some((x) => x.id === stored);
      const initial = valid ? stored : (a.data?.id || null);
      setSelectedSeasonId(initial);
    } catch (e) {
      // ignore; not authenticated etc.
    } finally { setReady(true); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const selectSeason = (id) => {
    setSelectedSeasonId(id);
    if (typeof localStorage !== "undefined") {
      if (id) localStorage.setItem("csp_season_id", id);
      else localStorage.removeItem("csp_season_id");
    }
  };

  const currentSeason = seasons.find((s) => s.id === selectedSeasonId) || activeSeason;

  return (
    <SeasonCtx.Provider value={{ seasons, activeSeason, selectedSeasonId, selectSeason, currentSeason, ready, reload: load }}>
      {children}
    </SeasonCtx.Provider>
  );
}

export function useSeason() {
  return useContext(SeasonCtx) || { seasons: [], activeSeason: null, selectedSeasonId: null, selectSeason: () => {}, currentSeason: null, ready: false, reload: () => {} };
}